// extracted by mini-css-extract-plugin
module.exports = {"root":"Report_root__3wA6a","container":"Report_container__2EDSw","tables":"Report_tables__hM1Ui"};